/* et-leash-gap.js - Ela Teila, 2026-10-15 (Rita).
   Pavadelio varianto pavadinime (EN) aplink "·" yra platus tarpai
   (U+2003 em space): "One size  ·  Length 47 in / 120 cm ...".
   Telefone tekstas netilpdavo i dydzio laukeli ir buvo nukerpamas.
   Cia tie tarpai pakeiciami iprastais - kaip LT ("Vienas dydis · ilgis"). Sriftas, dydis ir
   raidziu tarpai nekeiciami. LT tekste tokiu tarpu nera - nieko nedaro.
   Grazinimas: istrinti <script> eilute is snippets/et-scroll-keep.liquid. */
(function () {
  var RE = /\s* · \s*/g;
  function fix(root) {
    var els = (root || document).querySelectorAll('.product__info .select__selected-value, .product__info .combo-box__option-item, .product__info .combo-box__option-item *');
    for (var i = 0; i < els.length; i++) {
      var n = els[i].childNodes;
      for (var j = 0; j < n.length; j++) {
        if (n[j].nodeType === 3 && n[j].nodeValue.indexOf(' ') > -1) {
          n[j].nodeValue = n[j].nodeValue.replace(RE, ' · ');
        }
      }
    }
  }
  function run() {
    fix();
    var info = document.querySelector('.product__info');
    if (info) new MutationObserver(function () { fix(); }).observe(info, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
